<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''"></h3>
        </div>
        <div class="col text-right">
          <base-button type="primary" size="md" @click="openCreateModal()">Create New</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="appVersions"
      >
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Android App Version</th>
          <th class="text-center">iOS App Version</th>
          <th class="text-center">Updated Date</th>
          <th></th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.android_version}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.ios_version}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.updated_at}}</span>
              </div>
            </div>
          </td>
        </template>
      </base-table>
    </div>

    <div class="row" id="div-create_package_modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.create_app_version_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">CREATE APP VERSION</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">
                      <span>Android App Version:</span>
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-md-8">
                      <base-input
                        alternative
                        placeholder="Android App Version"
                        input-classes="form-control-alternative"
                        type="text"
                        v-model="createAppVersion.androidAppVersion"
                      />
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">
                      <span>iOS App Version:</span>
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-md-8">
                      <base-input
                        alternative
                        placeholder="Android App Version"
                        input-classes="form-control-alternative"
                        type="text"
                        v-model="createAppVersion.iosAppVersion"
                      />
                    </div>
                  </div>

                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.create_app_version_modal = false"
                    >Cancel</base-button>
                    <base-button type="success" class="my-4" @click="createAppVersions()">Create</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination :perPage="10" :total="totalAppVersions" :value="pageNumber"></base-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "app-versions-table",
  props: {
    type: {
      type: String
    },
    title: String
  },
  data() {
    return {
      totalAppVersions: 0,
      show: false,
      message: "",
      modals: {
        create_app_version_modal: false
      },
      createAppVersion: {
        iosAppVersion: "",
        androidAppVersion: ""
      }
    };
  },
  computed: {
    appVersions() {
      return this.$store.getters.appVersions;
    },
    pageNumber() {
      return parseInt(this.$route.query.page);
    },
    totalAppVersion() {
      return this.totalAppVersions;
    }
  },
  watch: {
    pageNumber() {
      this.getAppVersions(this.$route.query.page);
    }
  },
  mounted() {
    this.getAppVersions(1);
    this.getTotalAppVersions();
  },
  methods: {
    getAppVersions: function(page_number) {
      this.$store.dispatch("fetchAppVersions", page_number).then(response => {
        this.$store.dispatch("updateState", {
          key: "appVersions",
          value: response.data
        });
      });
    },

    getTotalAppVersions() {
      this.$store.dispatch("fetchTotalAppVersion").then(response => {
        this.totalAppVersions = response.data;
      });
    },

    createAppVersions() {
      this.$store
        .dispatch("createAppVersion", {
          ios_version: this.createAppVersion.iosAppVersion,
          android_version: this.createAppVersion.androidAppVersion
        })
        .then(response => {
          if (response.data.error == "1000") {
            this.modals.create_app_version_modal = false;
            this.getAppVersions(this.$route.query.page);
          } else if (response.data.error == "9999") {
            this.message = response.data.message.replace("\r\n", "<br />");
            this.show = true;
          }
        });
    },

    openCreateModal: function() {
      this.modals.create_app_version_modal = true;
      this.show = false;
      this.message = "";
      this.createAppVersion.iosAppVersion = "";
      this.createAppVersion.androidAppVersion = "";
    }
  }
};
</script>
<style>
</style>
